export const absent_letter = [
    {
        path: '/absent_letter/daily',
        component: () => import('@/absent_letter_v3/AbsentLetterPage.vue')
    }
]